<i class="attachment-action-icon" i-bs [name]="icon" width="17" height="17"></i>
<span *ngIf="text" class="attachment-action-text">{{text}}</span>
